const ES = {
    title: 'Gestión',
    unsubscription: {
        title: 'Bajas de clientes',
        table: {
            columns: {
                id: 'ID',
                date: 'Fecha y hora',
                client: 'Cliente',
                managed: 'Gestion',
                status: 'Estado',
                actions: 'Acciones',
            },
            status: {
                title: 'Estado',
                1: 'Pendiente',
                2: 'Aprobada',
                3: 'Rechazada',
                4: 'Revisar',
                5: 'Cancelada'
            },
            details: {
                title: 'Detalle',
                by: 'por: ',
                modal: {
                    title: 'Baja de cliente',
                    managed: 'Gestionada por',
                    date: 'Fecha y hora',
                    client: 'Cliente',
                    unsubscriptionDate: 'Fecha de alta',
                    document: 'INE',
                    reason: 'Motivo de la baja'
                }
            }
        }
    },
    consultants: {
        title: 'Consultoras admisibles',
        subTitle: 'Consultoras admisibles',
        manage: 'Gestionar consultoras',
        alert: {
            error: {
                extension: 'El formato del archivo es inválido',
                size: 'El archivo está vacío o excede el límite máximo permitido (1 MB).',
                upload: 'Se produjo un error al cargar el archivo, por favor intente nuevamente'
            }
        },
        dragZone: {
            buttonDrag: 'Seleccionar archivo',
            active: 'Suelta los archivos aquí...',
            inactive: 'Seleccionar o arrastrar el archivo',
            subtitle: 'xls o xlsx, peso inferior a 1 MB'
        },
        buttonCancel: 'Cancelar',
        buttonConfirm: 'Subir',
        loadButton: 'Cargar consultoras admisibles',
        constants: {
            file: 'Fila',
            created: 'Se crearon ',
            updated: 'Se modificaron ',
            total: 'Total de registros procesados ',
            consultants: ' consultoras'

        },
        validateErrors: {
            headerFail: 'La primera fila no parece ser una cabecera válida.',
            emptyRows: 'El archivo no contiene ninguna fila con datos.',
            rowsExceeded: 'El archivo contiene más filas de las permitidas (10.000).',
            rowsSparse: 'El archivo no contiene exactamente 11 columnas.',
            invalidColumns: 'No tiene exactamente 7 columnas.',
            emptyCell: 'La celda no debe estar vacía.',
            invalidDni: 'El INE no es válido (debe tener entre 7 y 8 dígitos).',
            duplicatedDni: 'El INE está duplicado en el archivo.',
            invalidGender: 'El género no es válido (debe ser "M" o "F").',
            invalidSupportCard: 'El valor en Admite Tarjeta no es válido (debe ser "si" o "no").',
            invalidCardLimitValue: 'El límite de la tarjeta debe ser un número.',
            invalidCardLimitAmount: 'El límite de la tarjeta debe ser mayor que 0 si Admite Tarjeta es "si".',
            invalidSupportPaymentLink: 'El valor en Admite Link de Pago no es válido (debe ser "si" o "no").',
            invalidSupportAccount: 'El valor en Admite Cuenta no es válido (debe ser "si" o "no").',
            invalidLevel: 'El valor en Nivel no es válido.',
            invalidDwellTime: 'El valor en Tiempo de Permanencia no es válido (debe ser un texto).',
            invalidSector: 'El valor en Sector no es válido (debe ser un texto).',
            invalidManagement: 'El valor en Gerencia no es válido (debe ser un texto).'
        },
        success: 'Documento procesado correctamente',
        fail: 'El archivo no pudo ser procesado',
        table: {
            title: 'Listado de Consultoras admisibles',
            placeholder: 'Buscar por INE...',
            columns: {
                id: 'ID',
                fullName: 'Nombre y Apellido',
                document: 'INE',
                level: 'Nivel',
                gender: 'Género',
                time: 'Tiempo en casa',
                sector: 'Sector',
                management: 'Gerencia',
            }
        }

    },
    fraudPrevention: {
        title: 'Prevención de Fraude',
        subTitle: 'Listado de Reglas de Links de Pago',
    },

};

export default ES;
